<script>
import EllipsisMenu from '@/components/EllipsisMenu.vue';
import BaseRadio from '@/components/BaseRadio.vue';
import FileTile from '@/components/FileTile.vue';
import { units } from '@/utils/enum';

export default {
  name: 'MaterialBidTile',
  components: { FileTile, BaseRadio, EllipsisMenu },
  props: {
    item: Object,
    checked: Boolean,
  },
  computed: {
    menuItems() {
      return [
        { text: 'Редактировать', icon: 'edit', handler: () => { this.$emit('edit'); } },
        { text: 'Удалить', icon: 'trash', handler: () => { this.$emit('delete'); } },
      ];
    },
    supplierName() { return this.item.supplierManual?.name; },
    supplierWebsite() { return this.item.supplierManual?.website; },
    supplierPhone() { return this.item.supplierManual?.phone; },
    supplierAddress() { return this.item.supplierManual?.address; },
    managerEmail() { return this.item.supplierManual?.managerEmail; },
    managerPhone() { return this.item.supplierManual?.managerPhone; },
    managerName() { return this.item.supplierManual?.managerName; },
    totalVolume() {
      const { volume, quantity, volumeUnit } = this.item;
      if (!volume || !quantity || !volumeUnit) return '-';

      const total = volume * quantity;
      const unit = units.volume[volumeUnit];
      return `${total} ${unit}`;
    },
    price() {
      const { price, priceCurrency } = this.item;
      if (!price || !priceCurrency) return '-';

      const unit = units.currency[priceCurrency];
      return `${price} ${unit}`;
    },
    totalPrice() {
      const { price, priceCurrency, quantity } = this.item;
      if (!price || !priceCurrency || !quantity) return '-';

      const total = quantity * price;
      const unit = units.currency[priceCurrency];
      return `${total} ${unit}`;
    },
  },
};
</script>

<template lang="pug">
.exchange-bid-tile(:class="{ checked }")
  BaseRadio.radio(:checked="checked" @check="$emit('check')")
  .main
    .name {{ supplierName }}
    a.site(v-if="supplierWebsite" :href="supplierWebsite") {{ supplierWebsite }}
    a.phone(v-if="supplierPhone" :href="`tel:${supplierPhone}`") {{ supplierPhone }}
    .address {{ supplierAddress }}
  .file
    FileTile(v-if="item.offer" :file="item.offer" sm)
  .comment {{ item.comment }}
  .col
    .key Цвет
    .val {{ item.color || '-' }}
    .key Размер
    .val {{ item.size || '-' }}
    .key Название
    .val {{ item.name || '-' }}
  .col
    .key Количество
    .val {{ totalVolume }}
    .key Цена
    .val {{ price }}
    .key Стоимость
    .val {{ totalPrice }}
  .col
    .key Менеджер
    .val {{ managerName || '-' }}
    .key Телефон
    a(v-if="managerPhone" :href="`tel:${managerPhone}`").val {{ managerPhone }}
    div(v-else) -
    .key e-mail
    a(v-if="managerEmail" :href="`mailto:${managerEmail}`").val {{ managerEmail }}
    div(v-else) -
  EllipsisMenu.menu(:items="menuItems")
</template>

<style scoped lang="scss">
.exchange-bid-tile{
  display: grid;
  gap: 12px;
  align-items: center;
  grid-template-columns: 55px 15fr 12fr 9fr 17fr 13fr 8fr 10fr 12fr 13fr 12fr 24px;
  position: relative;

  .col, .comment {
    grid-column: auto / 2 span;
  }

  padding: 26px 10px 26px 22px;

  background: #FBFCFD;
  border: 1px solid #FBFCFD;
  border-radius: 6px;
  border-left-width: 12px;

  &:before {
    display: block;
    content: '';
    position: absolute;
    background: #fff;
    border-radius: 4px;
    width: 10px;
    top: 0;
    left: -5px;
    bottom: 0;
  }

  &.checked {
    border-color: #33A1FB;
  }
}

.radio {
  align-self: start;
}

.name {
  font-size: 14px;
  line-height: 18.5px;
  font-weight: 700;
  margin-bottom: 3px;
}

.site, .phone, .address {
  display: block;
  color: #1E3147;
  font-size: 12px;
  line-height: 18px;
}

.site, .phone {
  color: #33A1FB;
  text-decoration: underline;
}

.file {
  min-width: 0;
}

.comment {
  font-size: 12px;
  line-height: 20px;
  color: #1E3147;
}

.col {
  font-size: 12px;
  line-height: 20px;
  display: grid;
  grid-template-columns: 1fr 2fr;
  row-gap: 8px;
  column-gap: 12px;

  .key {
    color: #92A0B0;
  }

  .val {
    color: #1E3147;
    font-weight: 700;
  }
}

.menu {
  align-self: start;
}


</style>
